import { render, staticRenderFns } from "./ImageBg.vue?vue&type=template&id=5db3c20a"
import script from "./ImageBg.vue?vue&type=script&lang=js"
export * from "./ImageBg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports